import { useMediaQuery } from '@vueuse/core'

export const useResponsiveScreen = () => {
  const isMobile = useMediaQuery('(max-width: 840px)')
  const isLaptop = useMediaQuery('(max-width: 1280px)')
  const isDesktop = useMediaQuery('(min-width: 1280px)')

  return { isDesktop, isLaptop, isMobile }
}